import { Schema_CvExtensionSection } from './schemas/cv_extension_section.model';
import { Schema_InspectionReport_30 } from './schemas/inspection_report_30.model';
import { Schema_InspectionReport_32 } from './schemas/inspection_report_32.model';
import { Schema_InspectionReport_34 } from './schemas/inspection_report_34.model';
import { Schema_InspectionReport_40 } from './schemas/inspection_report_40.model';
import { InspectionReport_Metadatum } from './schemas/schema_shared.model';

export class SchemaModel {
	CV_EXTENSION_SECTION?: Schema_CvExtensionSection;
	InspectionReport?: Schema_InspectionReport_30 | Schema_InspectionReport_32 | Schema_InspectionReport_34 | Schema_InspectionReport_40;
	Metadata?: InspectionReport_Metadatum[];
}
